import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from 'client/environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SocketIoService {
  private readonly _logSubject = new Subject<string>();
  private readonly _apiCallAllSubject = new Subject<{ id: number, amount: number, endpoint: string, timestamp: string }[]>();
  private readonly _apiCallVacanciesSubject = new Subject<{ id: number, amount: number, endpoint: string, timestamp: string }[]>();
  private readonly _apiCallDirectApplySubject = new Subject<{ id: number, amount: number, endpoint: string, timestamp: string }[]>();
  private socket: Socket;

  constructor() {
    // initialize client with env URL
    const url = environment.socketUrl;
    this.socket = io(url, { path: '/socket.io', upgrade: true });
    this.setupSocketListener();
  }

  private setupSocketListener() {
    this.socket.on('log', (data: any) => {
      if (Array.isArray(data) && Object.keys(data[0] || {}).length > 0 && data[0].hasOwnProperty("endpoint")) {
        switch (data[0].endpoint) {
          case "all": this._apiCallAllSubject.next(data); break;
          case "vacancies": this._apiCallVacanciesSubject.next(data); break;
          case "direct-apply": this._apiCallDirectApplySubject.next(data); break;
        }
      } else {
        this._logSubject.next(data);
      }
    });
  }

  getLogs(): Observable<string> {
    return this._logSubject.asObservable();
  }

  getApiCallAll() {
    return this._apiCallAllSubject.asObservable();
  }

  getApiCallVacancies() {
    return this._apiCallVacanciesSubject.asObservable();
  }

  getApiCallDirectApply() {
    return this._apiCallDirectApplySubject.asObservable();
  }

  joinRoom(key: string, room: string): void {
    this.socket.io.opts.query = { key, room } as any;
    this.socket.emit('joinRoom', { key, room });
  }
}
